"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
function MakeAReservation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="relative py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl sm:text-5xl font-display font-bold text-foreground mb-4">Make A Reservation</h2>
          <p className="text-lg text-muted max-w-2xl mx-auto">Book your transportation request with Car Service Connecticut. Fill out the form below, and we'll get you on the road!</p>
        </div>

        <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="w-full rounded-lg shadow-soft overflow-hidden bg-secondary">
            <iframe src="https://book.mylimobiz.com/v4/CSC" className="w-full h-[800px] border-0" title="Car Service Connecticut Booking Widget" aria-label="Reservation booking form" />
          </div>
        </div>
      </div>
    </section>;
}
export default MakeAReservation;